import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { NavBar } from "../Navbar"
import { LandingSection } from "./LandingSection"

export const Clientes = () => {
  const colorText = "#253EAF"
  const title = ["CLIENTES", ""]
  const classTitle = "clientes"
  return (
    <>
      <NavBar colorText={colorText} classTitle={classTitle} />
      <StaticImage
        src="../../images/clientes/hoteleria.png"
        placeholder="blurred"
        alt="clientes background"
        className="clientes-background"
      />
      <section id="Clientes" className={`${classTitle}-section`}>
        <LandingSection classTitle={classTitle} title={title} />
      </section>
    </>
  )
}
